<template>
  <Component :is="component" />
</template>

<script>
import GetHelp from '../../components/Widgets/GetHelp.vue'
import Logo from '../../components/Widgets/Logo.vue'
import TopMenu from '../../components/Widgets/TopMenu.vue'

import globalStore from '../../lib/global-event-store/'
export default {
  mounted() {
    const id = this.$root.$data.id
    globalStore.dispatch(id, 'sendGaEvent', { action: `MOUNTED/${this.type}` })
  },
  computed: {
    type() {
      return this.$root.$data.props.type.toUpperCase()
    },
    component() {
      switch (this.type) {
        case 'GET_HELP':
          return GetHelp
        case 'LOGO':
          return Logo
        case 'TOP_MENU':
          return TopMenu
        default:
          return null
      }
    }
  }
}
</script>

<style scoped>
</style>
